import { parsePhoneNumber, ParseError } from 'libphonenumber-js';
export default function phoneParser(candidate, country) {
  var error = null;
  var phoneNumber;

  try {
    phoneNumber = parsePhoneNumber(candidate || '', country);
  } catch (err) {
    if (err instanceof ParseError) {
      error = err;
    } else {
      throw err;
    }
  }

  return [error, phoneNumber];
}